import { render, staticRenderFns } from "./ActividadesVideo.vue?vue&type=template&id=df0a83f4&scoped=true&"
import script from "./ActividadesVideo.vue?vue&type=script&lang=js&"
export * from "./ActividadesVideo.vue?vue&type=script&lang=js&"
import style0 from "./ActividadesVideo.vue?vue&type=style&index=0&id=df0a83f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0a83f4",
  null
  
)

export default component.exports